import React, { Component } from 'react';
import {
  Button,
  Card,
  Col,
  Divider,
  Form,
  Input,
  message,
  Modal,
  Popconfirm,
  Row,
  Table,
} from 'antd';
import moment from 'moment';
import {
  queryApportionInfo,
  queryCheckApportionDetail,
  queryDeleteApportionDetail,
  querySaveApportionDetail,
} from '@api/finance/apportion';
import ModalApportion from '@comm/apportion/ModalApportion2';
import { BackBtn } from '@comm/BackBtn';
import { queryDictExpend } from '@api/core/dict';

const FormItem = Form.Item;
const { confirm } = Modal;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      visible: false,
      expendType: [],
      dataInfo: {
        apportion: {},
      },
      deleteReason: '',
      loading: false,
    };
  }

  componentDidMount() {
    this.loadExpendType();
    this.getApportionInfo();
  }

  loadExpendType = () => {
    queryDictExpend().then(res => {
      if (res.statusCode === 200) {
        this.setState({
          expendType: res.data,
        });
      }
    });
  };

  findTypeName = type => {
    let typeName = '';
    this.state.expendType.forEach(item => {
      if (type === item.value) {
        typeName = item.key;
      }
    });
    return typeName;
  };

  getApportionInfo = () => {
    this.setState({ loading: true });
    queryApportionInfo({
      uuid: this.props.params.uuid,
    })
      .then(res => {
        if (res.statusCode === 200) {
          this.setState({
            budgetType: res.data.budgetType,
            data: res.data.details,
            dataInfo: {
              type: res.data.budgetType,
              apportion: {
                type: res.data.type,
              },
            },
          });
        } else {
          message.error(res.message);
        }
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.loadData(1, values.condition);
      }
    });
  };

  handleFormReset = e => {
    e.preventDefault();
    this.props.form.resetFields();
    this.loadData(1);
  };

  handleVisible = flag => {
    this.setState({
      visible: !!flag,
    });
  };

  saveApportionDetail = (uuid, params) => {
    this.setState({ loading: true });
    querySaveApportionDetail(uuid, params)
      .then(res => {
        if (res.statusCode === 200) {
          message.success(res.message);
          this.getApportionInfo();
        } else {
          message.error(res.message);
        }
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  confirmDeleteApportionDetail = uuid => {
    confirm({
      title: '是否删除分摊明细??',
      content: (
        <Input
          autoFocus
          onChange={e => {
            this.setState({ deleteReason: e.target.value });
          }}
          placeholder="请输入删除理由"
        />
      ),
      onOk: () => this.deleteApportionDetail(uuid),
    });
  };

  deleteApportionDetail = uuid => {
    queryDeleteApportionDetail({ uuid, reason: this.state.deleteReason }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.getApportionInfo();
        this.setState({ deleteReason: '' });
      } else {
        message.error(res.message);
      }
    });
  };

  checkApportionDetail = uuid => {
    this.setState({ loading: true });
    queryCheckApportionDetail({ uuid })
      .then(res => {
        if (res.statusCode === 200) {
          message.success(res.message);
          this.getApportionInfo();
        } else {
          message.error(res.message);
        }
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  handleOk = params => {
    this.apportion = params;
    this.handleVisible(false);
    if (params.details && params.details.length > 0) {
      params.details.forEach(detail => {
        detail.remark = params.remark;
      });
    }
    this.saveApportionDetail(this.props.params.uuid, params.details);
  };

  renderSearchForm = () => {
    const {
      form: { getFieldDecorator },
    } = this.props;
    return (
      <Form layout="inline" onSubmit={this.handleSubmit} style={{ textAlign: 'right' }}>
        <FormItem label="搜索条件">
          {getFieldDecorator('condition')(<Input placeholder="请输入" />)}
        </FormItem>
        <FormItem>
          <Button type="primary" htmlType="submit">
            查询
          </Button>
          <Button style={{ marginLeft: 8, marginRight: '-16px' }} onClick={this.handleFormReset}>
            重置
          </Button>
        </FormItem>
      </Form>
    );
  };

  columns = () => {
    const { budgetType } = this.state;
    return [
      {
        title: '流水编号',
        dataIndex: 'no',
      },
      {
        title: '预算组名称',
        dataIndex: 'groupName',
      },
      {
        title: '费用',
        dataIndex: 'price',
      },
      {
        title: '摘要(包括删除原因)',
        dataIndex: 'remark',
        width: '400px',
        render: (text, record) => {
          return (
            <p>
              {text}
              {record.deleteReason ? (
                <span style={{ color: 'red' }}>（{record.deleteReason}）</span>
              ) : null}
            </p>
          );
        },
      },
      {
        title: '预算科目',
        dataIndex: 'type',
        render: () => <span>{this.findTypeName(budgetType)}</span>,
      },
      {
        title: '分摊时间',
        dataIndex: 'updateTime',
        render: text => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '状态',
        dataIndex: 'done',
        render: (text, record) => {
          switch (record.status) {
            case 1:
              return (
                <div>
                  <Popconfirm
                    title="是否确认分摊？"
                    onConfirm={() => this.checkApportionDetail(record.uuid)}
                  >
                    <a href="#">确认分摊</a>
                  </Popconfirm>
                  <Divider type="vertical" />
                  <Popconfirm
                    title="是否删除分摊？"
                    onConfirm={() => {
                      this.confirmDeleteApportionDetail(record.uuid);
                    }}
                  >
                    <a href="#">删除</a>
                  </Popconfirm>
                </div>
              );
            case 2:
              return <span>已删除</span>;
            case 3:
              return <span>已确认</span>;
            default:
          }
        },
      },
    ];
  };

  render() {
    const { data, visible, dataInfo, expendType, loading } = this.state;
    return (
      <Card>
        <div className="tableList">
          <Row>
            <Col span={13}>
              <FormItem>
                <BackBtn />
                <Button type="primary" icon="plus" onClick={() => this.handleVisible(true)}>
                  添加
                </Button>
              </FormItem>
            </Col>
            {/* <Col span={11}>
							<div className="tableListForm">{this.renderSearchForm()}</div>
						</Col> */}
          </Row>
        </div>
        <Table
          rowKey="uuid"
          rowSelection={{}}
          columns={this.columns()}
          dataSource={data}
          loading={loading}
          pagination={false}
        />
        <ModalApportion
          onCancel={() => this.handleVisible(false)}
          dataInfo={{}}
          dataItem={dataInfo}
          visible={visible}
          onOk={this.handleOk}
          expendType={expendType}
        />
      </Card>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(Index);



// WEBPACK FOOTER //
// ./src/components/finance/apportion/PageRecord.js